export default "__VITE_ASSET__CzUDJIuk__"